import { Grid, styled } from '@mui/material';

export const DashboardChartCardContainer = styled(Grid)(({ theme }) => ({
  height: '400px',
  marginBottom: theme.spacing(1)
}));
